import {
  ContactCardContent,
  ContactCardContentProps,
} from '@grays-npm/component-library';

export const ListingContactCard: React.FC<ContactCardContentProps> = ({
  title,
  subtitle,
}) => <ContactCardContent title={title} subtitle={subtitle} iconSize="small" />;
